import React, { useState, useEffect } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Col, Input, Row } from "reactstrap";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate, useNavigation } from "react-router-dom";
import { Fn_AddEditData, Fn_DisplayData, Fn_FillListData } from "../../store/Functions";
import { API_WEB_URLS } from "../../constants/constAPI";
import ReactToggle from "react-toggle";

function AddRate() {
  const API_URL_SAVE = `${API_WEB_URLS.AddRate}/0/token`;
  const API_URL_EDIT = `${API_WEB_URLS.MASTER}/0/token/RateEdit/Id`;
  const API_URL = API_WEB_URLS.MASTER + "/0/token/FuelCategory";
  const [state, setState] = useState({
    id: 0,
    formData: {
      Name: "",
      Username: "",
      Password: "",
    },
    FillArray: [],
    isProgress: true,
  });

  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const Id = (location.state && location.state.Id) || 0;
    Fn_FillListData(dispatch, setState, 'FillArray', API_URL + '/Id/0');
    if (Id > 0) {
      setState((prevState) => ({
        ...prevState,
        id: Id,
      }));
      Fn_DisplayData(dispatch, setState, Id, API_URL_EDIT);
    }
  }, [location.state, dispatch]);

  const validationSchema = Yup.object({
    Rate: Yup.string().required("Name is required"),
    F_FuelCategory: Yup.string().required("Fuel category is required"),
  });

  const handleSubmit = (values) => {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const formData = new FormData();
    formData.append("Rate", values.Rate);
    formData.append("F_FuelCategory", values.F_FuelCategory);

    formData.append("UserId", obj.uid);

    Fn_AddEditData(
      dispatch,
      setState,
      { arguList: { id: state.id, formData } },
      API_URL_SAVE,
      true,
      "memberid",
      navigate,
      "/RateMaster"
    );
  };

  return (
    <div className="page-content">
      <Formik
        initialValues={state.formData}
        enableReinitialize={true}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ setFieldValue, values }) => (
          <Form className="form-horizontal">
             <Row>
              <Col lg='6' className="mb-3">
                <label htmlFor="F_FuelCategory" className="form-label">Fuel Category</label>
                <Field className="form-control" as="select" name="F_FuelCategory">
                  <option value="">Select Fuel Category</option>
                  {state.FillArray.length > 0 && state.FillArray.map((type) => (
                    <option key={type.Id} value={type.Id}>{type.Name}</option>
                  ))}
                </Field>
                <ErrorMessage name="F_FuelCategory" component="div" className="text-danger" />
              </Col>
            </Row>
            <Row>
              <Col lg="6" className="mb-3">
                <label htmlFor="Rate" className="form-label">
                  Rate
                </label>
                <Field className="form-control" type="text" name="Rate" />
                <ErrorMessage name="Rate" component="div" className="text-danger" />
              </Col>
            </Row>



          

       

            <Row>
              <Col lg="6" className="mt-3">
                <button type="submit" className="btn btn-primary btn-block">
                  Submit
                </button>
              </Col>
            </Row>
          </Form>
        )}
      </Formik>
    </div>
  );
}

export default AddRate;
